import BaseModel from "~/models/BaseModel";

export default class RecruitModel extends BaseModel {}
